var React = require('react');

function Quotemarks (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#a8117d;}")),React.createElement("path",{"className":"a","d":"M21.642,30.792V19.38C21.642,10.573,27.4,4.6,35.512,3l1.536,3.321a10.215,10.215,0,0,0-6.168,9.031h6.176v15.44ZM0,30.792V19.38C0,10.573,5.787,4.6,13.9,3l1.538,3.321a10.214,10.214,0,0,0-6.17,9.031h6.15v15.44Z","transform":"translate(0 -3)","key":1})]);
}

Quotemarks.defaultProps = {"width":"47.056","viewBox":"0 0 37.056 27.792"};

module.exports = Quotemarks;

Quotemarks.default = Quotemarks;
